import AcademicDataStore from '../../datastores/AcademicDataStore';

const data = {
  academicPlanProgress: {
    student: {
      academic: {
        campusDesc: 'Lima Sur',
        progDesc: 'INGENIERIA INDUSTRIAL'
      },
      profile: {
        studentCode: 'U19307030'
      },
      academicPlanProgress: {
        requiredCourses: {
          total: 62,
          approved: 42,
          pending: 20
        },
        credits: {
          total: 200,
          required: {
            total: 197,
            approved: 132,
            pending: 65
          },
          optional: {
            total: 3,
            approved: 2,
            pending: 1
          }
        }
      }
    }
  }
};

export default class AcademicDataStoreMock implements AcademicDataStore {
  getAcademicPlanProgress() {
    return data;
  }
}
